export default __webpack_public_path__ + "static/media/illustration-cloud-devops.ab310564.svg";